import React, { useContext, useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import { FetchLikePlusCard } from 'Services/Apis/likePlus/likePlusServices';

import {
  Col,
  VertContainer,
  VertBreadcrumb,
  VertIcon,
  VertTokens,
  VertLoading,
  Row,
} from '@vertem-core/vertice-ds';

import { RightOutlined } from '@ant-design/icons';

import 'Assets/styles/default/pages/likePlus/LikePlusPageStyles.less';

import CheckoutProvider from 'components/Checkout/CheckoutProvider';
import LikePlusAbout from 'components/LikePlus/LikePlusAbout/LikePlusAbout';
import LikePlusCopy from 'components/LikePlus/LikePlusCopy/LikePlusCopy';
import LikePlusGetYour from 'components/LikePlus/LikePlusGetYour/LikePlusGetYour';
import LikePlusMainBanner from 'components/LikePlus/LikePlusMainBanner/LikePlusMainBanner';
import LikePlusManage from 'components/LikePlus/LikePlusManage/LikePlusManage';
import LikePlusMenu from 'components/LikePlus/LikePlusMenu/LikePlusMenu';
import LikePlusRecharge from 'components/LikePlus/LikePlusRecharge/LikePlusRecharge';
import LikePlusFAQ from 'components/LikePlus/LikePlusFAQ';

import { cardCustomLabel, hasFaq } from 'Constants/LikePlus';

// LIKE PLUS PAGE
const LikePlus = () => {
  const userInfos = useSelector(({ oidc: data }) => data);
  const Participants = useSelector(({ Participants: data }) => data);
  const { designTokens } = useContext(VertTokens);

  /* states */
  const [isLoading, setIsLoading] = useState(false);
  const [hasLikePlusCard, setHasLikePlusCard] = useState(null);
  const [tabSelected, setTab] = useState('1');
  const [bannerSelected, setBanner] = useState(null);

  const documentNumber = Participants?.cpfCnpj.value;

  const breadcrumb = [
    { title: 'Início', path: '/' },
    { title: `Cartão ${cardCustomLabel}`, path: '/like-plus' },
  ];

  const [tabItems, setTabItems] = useState();

  useEffect(() => {
    if (hasLikePlusCard === null) return;

      setTabItems([
      {
        label: cardCustomLabel,
        key: '1',
        children: <LikePlusAbout />,
      },
      {
        label: !hasLikePlusCard ? 'Peça o seu' : 'Carregar saldo',
        key: '2',
        children: !hasLikePlusCard ? <LikePlusGetYour /> : <LikePlusRecharge />,
      },
      {
        label: 'Gerenciar cartão',
        key: '3',
        children: <LikePlusManage />,
      },
      {
        label: '2ª via',
        key: '4',
        children: <LikePlusCopy />,
      },
      ...(
        hasFaq ? [{
          label: 'FAQ',
          key: '5',
          children: <LikePlusFAQ />,
        }] : []
      )
    ])
  }, [hasLikePlusCard]);

  /* Handlers */
  const handleTab = (tab) => {
    setTab(tab);
  };

  const checkHasLikePlusCard = async () => {
    try {
      setIsLoading(true)
      const { data } = await FetchLikePlusCard(userInfos.user, documentNumber);
      setHasLikePlusCard(data?.hasCard);
      setIsLoading(false)
    } catch (e) {
      console.warn(e);
    }
  };

  const handleBannerImage = (tabSelected, hasCard) => {
    const { 'banners-like-plus': banners } = designTokens;

    if (!banners) return null;

    let result;

    if (banners && banners[tabSelected]) {
      result = hasCard
        ? banners[`${tabSelected}-hasCard`]
        : banners[tabSelected];
    } else {
      result = hasCard
        ? banners['default-hasCard']
        : banners['default'];
    }

    return result;
  };

  useEffect(() => {
    setBanner(handleBannerImage(tabSelected, hasLikePlusCard));
  }, [tabSelected, designTokens]);

  useEffect(() => {
    checkHasLikePlusCard();
  }, []);

  return (
    <CheckoutProvider>
      <Col className="like-plus-page-wrapper">
        <VertContainer
          className="like-plus-breadcrumb"
          spacingX="regular"
          spacingY="small"
        >
          <VertBreadcrumb hasBackButton={true}
            separator={<VertIcon component={RightOutlined} />}
            items={breadcrumb}
          />
        </VertContainer>

        {bannerSelected && (
          <LikePlusMainBanner bannerImage={bannerSelected} />
        )}

        {isLoading ? (
          <Row className="loading-container" justify={"center"}>
            <VertLoading size='small' type='spin' className='color-detached' />
          </Row>  
        ) : (
          <>
            {tabItems ? (
              <LikePlusMenu
                tabItems={tabItems}
                handleTab={handleTab}
                hasCard={hasLikePlusCard}
              />
            ) : ''}
          </>
        )}


      </Col>
    </CheckoutProvider>
  );
};

export default LikePlus;
